{
  "title": "False Life",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level necromancy",
  "level": 1,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (a small amount of alcohol or distilled spirits)",
  "duration": "1 hour",
  "description": [
    "Bolstering yourself with a necromantic facsimile of life, you gain 1d4 + 4 temporary hit points for the duration.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, you gain 5 additional temporary hit points for each slot level above 1st."
  ],
  "spellLists": ["artificer", "sorcerer", "wizard"]
}
